import * as CommonUx from '@abb/common-ux';
import * as Oidc from 'oidc-client';
import * as React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { PermissionConstants } from '@module/shared';
import PermissionsService from '@service/PermissionsService';
import { IAuthenticationProps, IConnectedComponent } from 'reducers';
import { Settings } from '../Settings';

export class RequireAuthenticationComponent extends React.Component<IConnectedComponent & IAuthenticationProps, any> {
  constructor(props: any) {
    super(props);
    this.state = { userManager: new Oidc.UserManager(Settings) };

    this.onUserLoaded = this.onUserLoaded.bind(this);
    this.onSilentRenewError = this.onSilentRenewError.bind(this);
    this.onAccessTokenExpired = this.onAccessTokenExpired.bind(this);
    this.onAccessTokenExpiring = this.onAccessTokenExpiring.bind(this);
    this.onUserUnloaded = this.onUserUnloaded.bind(this);
    this.onUserSignedOut = this.onUserSignedOut.bind(this);
  }
  componentWillMount() {
    this.state.userManager.events.addUserLoaded(this.onUserLoaded);
    this.state.userManager.events.addSilentRenewError(this.onSilentRenewError);
    this.state.userManager.events.addAccessTokenExpired(this.onAccessTokenExpired);
    this.state.userManager.events.addAccessTokenExpiring(this.onAccessTokenExpiring);
    this.state.userManager.events.addUserUnloaded(this.onUserUnloaded);
    this.state.userManager.events.addUserSignedOut(this.onUserSignedOut);
  }
  componentWillUnmount() {
    this.state.userManager.events.removeUserLoaded(this.onUserLoaded);
    this.state.userManager.events.removeSilentRenewError(this.onSilentRenewError);
    this.state.userManager.events.removeAccessTokenExpired(this.onAccessTokenExpired);
    this.state.userManager.events.removeAccessTokenExpiring(this.onAccessTokenExpiring);
    this.state.userManager.events.removeUserUnloaded(this.onUserUnloaded);
    this.state.userManager.events.removeUserSignedOut(this.onUserSignedOut);
  }

  async componentDidMount() {
    if (!this.props.loggedInUser) {
      const user: Oidc.User = await this.state.userManager.getUser();
      await this.props.login(user);
    }
  }
  // event callback when the user has been loaded (on silent renew or redirect)
  async onUserLoaded(user: any) {
    await this.props.login(user);
  }

  // event callback when silent renew errored
  // tslint:disable:no-empty
  onSilentRenewError(error: any) {
  }

  // event callback when the access token expired
  onAccessTokenExpired() {
    this.props.tokenExpired();
  }

  // event callback when the user is logged out
  onUserUnloaded() {
  }

  // event callback when the user is expiring
  onAccessTokenExpiring() {
  }

  // event callback when the user is signed out
  onUserSignedOut() {
  }
  // tslint:enable:no-empty

  render() {
    const { children, loggedInUser, userPermissions } = this.props;
    if (loggedInUser && (!userPermissions || !userPermissions.permissions || !userPermissions.permissions.some(p => p.code === PermissionConstants.ManagePartInventory || p.code === PermissionConstants.AdministerPartInventory))) {
      this.props.history.push('/forbidden');
    }

    if (loggedInUser) {
      return children;
    }

    return (
      <div>
        <CommonUx.Cursor cursorSize={3} style={{ marginLeft: 2, marginTop: 5 }}>
          Log In Required
        </CommonUx.Cursor>
        <p>You must be logged-in to view this page.</p>
      </div>
    );
  }
}
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(RequireAuthenticationComponent));

function mapStateToProps(store: any) {
  return {
    loggedInUser: store.userState.loggedInUser,
    userPermissions: store.userState.userPermissions
  };
}

function mapDispatchToProps(dispatch: any, ownProps: any) {
  return {
    async login(user: any) {
      const userPermissions = await PermissionsService.getUserPermissions(user);
      if (user && !user.expired) {
        dispatch({ type: 'USER_LOGIN', loggedInUser: user, userPermissions });
      }
    },
    tokenExpired() {
      dispatch({ type: 'USER_LOGIN', loggedInUser: null });
    },
  };
}
